module.exports = __webpack_public_path__ + "img/th_37mm_Scalps.ad9e8ed7.jpg";